const countries: { code: string; name: string; phone: string }[] = [
  { code: 'US', name: 'United States', phone: '1' },
  { code: 'CA', name: 'Canada', phone: '1' },
  { code: 'GB', name: 'United Kingdom', phone: '44' },
  { code: 'AU', name: 'Australia', phone: '61' },
  { code: 'DE', name: 'Germany', phone: '49' },
  { code: 'FR', name: 'France', phone: '33' },
  { code: 'JP', name: 'Japan', phone: '81' },
  { code: 'CN', name: 'China', phone: '86' },
  { code: 'IN', name: 'India', phone: '91' },
  { code: 'BR', name: 'Brazil', phone: '55' },
  { code: 'RU', name: 'Russia', phone: '7' },
  { code: 'ZA', name: 'South Africa', phone: '27' },
  { code: 'MX', name: 'Mexico', phone: '52' },
  { code: 'KR', name: 'South Korea', phone: '82' },
  { code: 'ES', name: 'Spain', phone: '34' },
  { code: 'IT', name: 'Italy', phone: '39' },
  { code: 'ID', name: 'Indonesia', phone: '62' },
  { code: 'NG', name: 'Nigeria', phone: '234' },
  { code: 'EG', name: 'Egypt', phone: '20' },
  { code: 'SE', name: 'Sweden', phone: '46' },
  { code: 'CH', name: 'Switzerland', phone: '41' },
  { code: 'NL', name: 'Netherlands', phone: '31' },
  { code: 'BE', name: 'Belgium', phone: '32' },
  { code: 'AT', name: 'Austria', phone: '43' },
  { code: 'DK', name: 'Denmark', phone: '45' },
  { code: 'FI', name: 'Finland', phone: '358' },
  { code: 'NO', name: 'Norway', phone: '47' },
  { code: 'PL', name: 'Poland', phone: '48' },
  { code: 'UA', name: 'Ukraine', phone: '380' },
  { code: 'GR', name: 'Greece', phone: '30' },
  { code: 'TR', name: 'Turkey', phone: '90' },
  { code: 'IR', name: 'Iran', phone: '98' },
  { code: 'SA', name: 'Saudi Arabia', phone: '966' },
  { code: 'AE', name: 'United Arab Emirates', phone: '971' },
  { code: 'IL', name: 'Israel', phone: '972' },
  { code: 'SG', name: 'Singapore', phone: '65' },
  { code: 'MY', name: 'Malaysia', phone: '60' },
  { code: 'TH', name: 'Thailand', phone: '66' },
  { code: 'VN', name: 'Vietnam', phone: '84' },
  { code: 'PH', name: 'Philippines', phone: '63' },
  { code: 'PK', name: 'Pakistan', phone: '92' },
  { code: 'BD', name: 'Bangladesh', phone: '880' },
  { code: 'NP', name: 'Nepal', phone: '977' },
  { code: 'AF', name: 'Afghanistan', phone: '93' },
  { code: 'MM', name: 'Myanmar', phone: '95' },
  { code: 'LK', name: 'Sri Lanka', phone: '94' },
  { code: 'KH', name: 'Cambodia', phone: '855' },
  { code: 'LA', name: 'Laos', phone: '856' },
  { code: 'MN', name: 'Mongolia', phone: '976' },
  { code: 'KP', name: 'North Korea', phone: '850' },
  { code: 'HK', name: 'Hong Kong', phone: '852' },
  { code: 'TW', name: 'Taiwan', phone: '886' },
  { code: 'MO', name: 'Macau', phone: '853' },
  { code: 'MV', name: 'Maldives', phone: '960' },
  { code: 'BT', name: 'Bhutan', phone: '975' },
  { code: 'BN', name: 'Brunei', phone: '673' },
  { code: 'TL', name: 'Timor-Leste', phone: '670' },
  { code: 'ID', name: 'Indonesia', phone: '62' },
  { code: 'MY', name: 'Malaysia', phone: '60' },
  { code: 'SG', name: 'Singapore', phone: '65' },
  { code: 'TH', name: 'Thailand', phone: '66' },
  { code: 'VN', name: 'Vietnam', phone: '84' },
  { code: 'PH', name: 'Philippines', phone: '63' },
  { code: 'PK', name: 'Pakistan', phone: '92' },
  { code: 'BD', name: 'Bangladesh', phone: '880' },
  { code: 'NP', name: 'Nepal', phone: '977' },
  { code: 'AF', name: 'Afghanistan', phone: '93' },
  { code: 'MM', name: 'Myanmar', phone: '95' },
  { code: 'LK', name: 'Sri Lanka', phone: '94' },
  { code: 'KH', name: 'Cambodia', phone: '855' },
  { code: 'LA', name: 'Laos', phone: '856' },
  { code: 'MN', name: 'Mongolia', phone: '976' },
  { code: 'KP', name: 'North Korea', phone: '850' },
  { code: 'KR', name: 'South Korea', phone: '82' },
  { code: 'JP', name: 'Japan', phone: '81' },
  { code: 'CN', name: 'China', phone: '86' },
  { code: 'TW', name: 'Taiwan', phone: '886' },
  { code: 'HK', name: 'Hong Kong', phone: '852' },
  { code: 'MO', name: 'Macau', phone: '853' },
  { code: 'BT', name: 'Bhutan', phone: '975' },
  { code: 'BN', name: 'Brunei', phone: '673' },
  { code: 'MV', name: 'Maldives', phone: '960' },
  { code: 'TL', name: 'Timor-Leste', phone: '670' },
  { code: 'IN', name: 'India', phone: '91' },
  { code: 'PG', name: 'Papua New Guinea', phone: '675' },
  { code: 'SB', name: 'Solomon Islands', phone: '677' },
  { code: 'VU', name: 'Vanuatu', phone: '678' },
  { code: 'FJ', name: 'Fiji', phone: '679' },
  { code: 'PW', name: 'Palau', phone: '680' },
  { code: 'KI', name: 'Kiribati', phone: '686' },
  { code: 'MH', name: 'Marshall Islands', phone: '692' },
  { code: 'FM', name: 'Micronesia', phone: '691' },
  { code: 'NR', name: 'Nauru', phone: '674' },
  { code: 'WS', name: 'Samoa', phone: '685' },
  { code: 'TO', name: 'Tonga', phone: '676' },
  { code: 'TV', name: 'Tuvalu', phone: '688' },
  { code: 'NZ', name: 'New Zealand', phone: '64' },
  { code: 'AU', name: 'Australia', phone: '61' },
  { code: 'ID', name: 'Indonesia', phone: '62' },
  { code: 'MY', name: 'Malaysia', phone: '60' },
  { code: 'SG', name: 'Singapore', phone: '65' },
  { code: 'TH', name: 'Thailand', phone: '66' },
  { code: 'VN', name: 'Vietnam', phone: '84' },
  { code: 'PH', name: 'Philippines', phone: '63' },
  { code: 'PK', name: 'Pakistan', phone: '92' },
  { code: 'BD', name: 'Bangladesh', phone: '880' },
  { code: 'NP', name: 'Nepal', phone: '977' },
  { code: 'AF', name: 'Afghanistan', phone: '93' },
  { code: 'MM', name: 'Myanmar', phone: '95' },
  { code: 'LK', name: 'Sri Lanka', phone: '94' },
  { code: 'KH', name: 'Cambodia', phone: '855' },
  { code: 'LA', name: 'Laos', phone: '856' },
  { code: 'MN', name: 'Mongolia', phone: '976' },
  { code: 'KP', name: 'North Korea', phone: '850' },
  { code: 'KR', name: 'South Korea', phone: '82' },
  { code: 'JP', name: 'Japan', phone: '81' },
  { code: 'CN', name: 'China', phone: '86' },
  { code: 'TW', name: 'Taiwan', phone: '886' },
  { code: 'HK', name: 'Hong Kong', phone: '852' },
  { code: 'MO', name: 'Macau', phone: '853' },
  { code: 'BT', name: 'Bhutan', phone: '975' },
  { code: 'BN', name: 'Brunei', phone: '673' },
  { code: 'MV', name: 'Maldives', phone: '960' },
  { code: 'TL', name: 'Timor-Leste', phone: '670' },
  { code: 'IN', name: 'India', phone: '91' },
  { code: 'PG', name: 'Papua New Guinea', phone: '675' },
  { code: 'SB', name: 'Solomon Islands', phone: '677' },
  { code: 'VU', name: 'Vanuatu', phone: '678' },
  { code: 'FJ', name: 'Fiji', phone: '679' },
  { code: 'PW', name: 'Palau', phone: '680' },
  { code: 'KI', name: 'Kiribati', phone: '686' },
  { code: 'MH', name: 'Marshall Islands', phone: '692' },
  { code: 'FM', name: 'Micronesia', phone: '691' },
  { code: 'NR', name: 'Nauru', phone: '674' },
  { code: 'WS', name: 'Samoa', phone: '685' },
  { code: 'TO', name: 'Tonga', phone: '676' },
  { code: 'TV', name: 'Tuvalu', phone: '688' },
  { code: 'CK', name: 'Cook Islands', phone: '682' },
  { code: 'NU', name: 'Niue', phone: '683' },
  { code: 'TK', name: 'Tokelau', phone: '690' },
  { code: 'PF', name: 'French Polynesia', phone: '689' },
  { code: 'NC', name: 'New Caledonia', phone: '687' },
  { code: 'WF', name: 'Wallis and Futuna', phone: '681' },
  { code: 'GU', name: 'Guam', phone: '1-671' },
  { code: 'MP', name: 'Northern Mariana Islands', phone: '1-670' },
  { code: 'PR', name: 'Puerto Rico', phone: '1-787, 1-939' },
  { code: 'VI', name: 'U.S. Virgin Islands', phone: '1-340' },
  { code: 'AS', name: 'American Samoa', phone: '1-684' },
  { code: 'UM', name: 'U.S. Minor Outlying Islands', phone: '1' },
  { code: 'CA', name: 'Canada', phone: '1' },
  { code: 'US', name: 'United States', phone: '1' },
  { code: 'MX', name: 'Mexico', phone: '52' },
  { code: 'GT', name: 'Guatemala', phone: '502' },
  { code: 'BZ', name: 'Belize', phone: '501' },
  { code: 'SV', name: 'El Salvador', phone: '503' },
  { code: 'HN', name: 'Honduras', phone: '504' },
  { code: 'NI', name: 'Nicaragua', phone: '505' },
  { code: 'CR', name: 'Costa Rica', phone: '506' },
  { code: 'PA', name: 'Panama', phone: '507' },
  { code: 'DO', name: 'Dominican Republic', phone: '1-809, 1-829, 1-849' },
  { code: 'HT', name: 'Haiti', phone: '509' },
  { code: 'CU', name: 'Cuba', phone: '53' },
  { code: 'JM', name: 'Jamaica', phone: '1-876' },
  { code: 'TT', name: 'Trinidad and Tobago', phone: '1-868' },
  { code: 'GY', name: 'Guyana', phone: '592' },
  { code: 'SR', name: 'Suriname', phone: '597' },
  { code: 'GF', name: 'French Guiana', phone: '594' },
  { code: 'BR', name: 'Brazil', phone: '55' },
  { code: 'AR', name: 'Argentina', phone: '54' },
  { code: 'CL', name: 'Chile', phone: '56' },
  { code: 'CO', name: 'Colombia', phone: '57' },
  { code: 'PE', name: 'Peru', phone: '51' },
  { code: 'VE', name: 'Venezuela', phone: '58' },
  { code: 'BO', name: 'Bolivia', phone: '591' },
  { code: 'EC', name: 'Ecuador', phone: '593' },
  { code: 'PY', name: 'Paraguay', phone: '595' },
  { code: 'UY', name: 'Uruguay', phone: '598' },
  { code: 'CW', name: 'Curaçao', phone: '599' },
  { code: 'BB', name: 'Barbados', phone: '1-246' },
  { code: 'AG', name: 'Antigua and Barbuda', phone: '1-268' },
  { code: 'DM', name: 'Dominica', phone: '1-767' },
  { code: 'GD', name: 'Grenada', phone: '1-473' },
  { code: 'KN', name: 'Saint Kitts and Nevis', phone: '1-869' },
  { code: 'LC', name: 'Saint Lucia', phone: '1-758' },
  { code: 'VC', name: 'Saint Vincent and the Grenadines', phone: '1-784' },
  { code: 'BS', name: 'Bahamas', phone: '1-242' },
  { code: 'KY', name: 'Cayman Islands', phone: '1-345' },
  { code: 'BM', name: 'Bermuda', phone: '1-441' },
  { code: 'VG', name: 'British Virgin Islands', phone: '1-284' },
  { code: 'AI', name: 'Anguilla', phone: '1-264' },
  { code: 'MS', name: 'Montserrat', phone: '1-664' },
  { code: 'TC', name: 'Turks and Caicos Islands', phone: '1-649' },
  { code: 'AW', name: 'Aruba', phone: '297' },
  { code: 'GL', name: 'Greenland', phone: '299' },
  { code: 'PM', name: 'Saint Pierre and Miquelon', phone: '508' },
  { code: 'ES', name: 'Spain', phone: '34' },
  { code: 'FR', name: 'France', phone: '33' },
  { code: 'GB', name: 'United Kingdom', phone: '44' },
  { code: 'DE', name: 'Germany', phone: '49' },
  { code: 'IT', name: 'Italy', phone: '39' },
  { code: 'IE', name: 'Ireland', phone: '353' },
  { code: 'NL', name: 'Netherlands', phone: '31' },
  { code: 'BE', name: 'Belgium', phone: '32' },
  { code: 'CH', name: 'Switzerland', phone: '41' },
  { code: 'AT', name: 'Austria', phone: '43' },
  { code: 'SE', name: 'Sweden', phone: '46' },
  { code: 'NO', name: 'Norway', phone: '47' },
  { code: 'DK', name: 'Denmark', phone: '45' },
  { code: 'FI', name: 'Finland', phone: '358' },
  { code: 'PT', name: 'Portugal', phone: '351' },
  { code: 'LU', name: 'Luxembourg', phone: '352' },
  { code: 'MC', name: 'Monaco', phone: '377' },
  { code: 'SM', name: 'San Marino', phone: '378' },
  { code: 'VA', name: 'Vatican City', phone: '379' },
  { code: 'PL', name: 'Poland', phone: '48' },
  { code: 'CZ', name: 'Czech Republic', phone: '420' },
  { code: 'SK', name: 'Slovakia', phone: '421' },
  { code: 'HU', name: 'Hungary', phone: '36' },
  { code: 'RO', name: 'Romania', phone: '40' },
  { code: 'BG', name: 'Bulgaria', phone: '359' },
  { code: 'GR', name: 'Greece', phone: '30' },
  { code: 'AL', name: 'Albania', phone: '355' },
  { code: 'HR', name: 'Croatia', phone: '385' },
  { code: 'SI', name: 'Slovenia', phone: '386' },
  { code: 'BA', name: 'Bosnia and Herzegovina', phone: '387' },
  { code: 'ME', name: 'Montenegro', phone: '382' },
  { code: 'RS', name: 'Serbia', phone: '381' },
  { code: 'MK', name: 'North Macedonia', phone: '389' },
  { code: 'XK', name: 'Kosovo', phone: '383' },
  { code: 'MT', name: 'Malta', phone: '356' },
  { code: 'CY', name: 'Cyprus', phone: '357' },
  { code: 'EE', name: 'Estonia', phone: '372' },
  { code: 'LV', name: 'Latvia', phone: '371' },
  { code: 'LT', name: 'Lithuania', phone: '370' },
  { code: 'RU', name: 'Russia', phone: '7' },
  { code: 'BY', name: 'Belarus', phone: '375' },
  { code: 'UA', name: 'Ukraine', phone: '380' },
  { code: 'MD', name: 'Moldova', phone: '373' },
  { code: 'AZ', name: 'Azerbaijan', phone: '994' },
  { code: 'GE', name: 'Georgia', phone: '995' },
  { code: 'AM', name: 'Armenia', phone: '374' },
  { code: 'TR', name: 'Turkey', phone: '90' },
  { code: 'IL', name: 'Israel', phone: '972' },
  { code: 'PS', name: 'Palestine', phone: '970' },
  { code: 'JO', name: 'Jordan', phone: '962' },
  { code: 'LB', name: 'Lebanon', phone: '961' },
  { code: 'SY', name: 'Syria', phone: '963' },
  { code: 'IQ', name: 'Iraq', phone: '964' },
  { code: 'KW', name: 'Kuwait', phone: '965' },
  { code: 'SA', name: 'Saudi Arabia', phone: '966' },
  { code: 'YE', name: 'Yemen', phone: '967' },
  { code: 'OM', name: 'Oman', phone: '968' },
  { code: 'AE', name: 'United Arab Emirates', phone: '971' },
  { code: 'QA', name: 'Qatar', phone: '974' },
  { code: 'BH', name: 'Bahrain', phone: '973' },
  { code: 'IR', name: 'Iran', phone: '98' },
  { code: 'EG', name: 'Egypt', phone: '20' },
  { code: 'LY', name: 'Libya', phone: '218' },
  { code: 'TN', name: 'Tunisia', phone: '216' },
  { code: 'DZ', name: 'Algeria', phone: '213' },
  { code: 'MA', name: 'Morocco', phone: '212' },
  { code: 'SD', name: 'Sudan', phone: '249' },
  { code: 'SS', name: 'South Sudan', phone: '211' },
  { code: 'ET', name: 'Ethiopia', phone: '251' },
  { code: 'ER', name: 'Eritrea', phone: '291' },
  { code: 'DJ', name: 'Djibouti', phone: '253' },
  { code: 'SO', name: 'Somalia', phone: '252' },
  { code: 'KE', name: 'Kenya', phone: '254' },
  { code: 'UG', name: 'Uganda', phone: '256' },
  { code: 'TZ', name: 'Tanzania', phone: '255' },
  { code: 'RW', name: 'Rwanda', phone: '250' },
  { code: 'BI', name: 'Burundi', phone: '257' },
  { code: 'CD', name: 'Democratic Republic of the Congo', phone: '243' },
  { code: 'CG', name: 'Republic of the Congo', phone: '242' },
  { code: 'GA', name: 'Gabon', phone: '241' },
  { code: 'CM', name: 'Cameroon', phone: '237' },
  { code: 'CF', name: 'Central African Republic', phone: '236' },
  { code: 'TD', name: 'Chad', phone: '235' },
  { code: 'NG', name: 'Nigeria', phone: '234' },
  { code: 'NE', name: 'Niger', phone: '227' },
  { code: 'BJ', name: 'Benin', phone: '229' },
  { code: 'TG', name: 'Togo', phone: '228' },
  { code: 'GH', name: 'Ghana', phone: '233' },
  { code: 'CI', name: 'Ivory Coast', phone: '225' },
  { code: 'BF', name: 'Burkina Faso', phone: '226' },
  { code: 'LR', name: 'Liberia', phone: '231' },
  { code: 'SL', name: 'Sierra Leone', phone: '232' },
  { code: 'GM', name: 'Gambia', phone: '220' },
  { code: 'SN', name: 'Senegal', phone: '221' },
  { code: 'GW', name: 'Guinea-Bissau', phone: '245' },
  { code: 'GN', name: 'Guinea', phone: '224' },
  { code: 'CV', name: 'Cape Verde', phone: '238' },
  { code: 'ML', name: 'Mali', phone: '223' },
  { code: 'MR', name: 'Mauritania', phone: '222' },
  { code: 'SC', name: 'Seychelles', phone: '248' },
  { code: 'MU', name: 'Mauritius', phone: '230' },
  { code: 'KM', name: 'Comoros', phone: '269' },
  { code: 'MG', name: 'Madagascar', phone: '261' },
  { code: 'MZ', name: 'Mozambique', phone: '258' },
  { code: 'ZM', name: 'Zambia', phone: '260' },
  { code: 'MW', name: 'Malawi', phone: '265' },
  { code: 'ZW', name: 'Zimbabwe', phone: '263' },
  { code: 'NA', name: 'Namibia', phone: '264' },
  { code: 'BW', name: 'Botswana', phone: '267' },
  { code: 'ZA', name: 'South Africa', phone: '27' },
  { code: 'LS', name: 'Lesotho', phone: '266' },
  { code: 'SZ', name: 'Eswatini', phone: '268' },
  { code: 'AO', name: 'Angola', phone: '244' },
  { code: 'ST', name: 'Sao Tome and Principe', phone: '239' },
  { code: 'GQ', name: 'Equatorial Guinea', phone: '240' },
  { code: 'GA', name: 'Gabon', phone: '241' },
  { code: 'RE', name: 'Reunion', phone: '262' },
  { code: 'YT', name: 'Mayotte', phone: '262' },
  {
    code: 'SH',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    phone: '290',
  },
  { code: 'EH', name: 'Western Sahara', phone: '212' },
];

export default countries;
